import { type AgriWebbFarmT, type AgriWebbSeasonalMobResultT } from '@ruminati/types_v2/agriwebb'
import { defineStore } from 'pinia'
import { computed, ref, watch } from 'vue'

import { useOrganisationStore } from './organisations'

export const useAgriwebbStore = defineStore('agriwebb', () => {
  const organisationStore = useOrganisationStore()

  const agriwebbFarms = ref<Array<AgriWebbFarmT> | undefined>()
  const agriwebbFarmsError = ref<string | undefined>()

  const agriwebbMobs = ref<AgriWebbSeasonalMobResultT | undefined>()
  const agriwebbMobsError = ref<string | undefined>()

  const agriwebbReauthRequired = computed(
    () =>
      agriwebbFarmsError.value === 'INTEGRATION_REAUTH_REQUIRED' ||
      agriwebbMobsError.value === 'INTEGRATION_REAUTH_REQUIRED',
  )

  function setAgriwebbFarms(farms: Array<AgriWebbFarmT>) {
    agriwebbFarms.value = farms
  }

  function setAgriwebbFarmsError(code: string | undefined) {
    agriwebbFarmsError.value = code
  }

  function setAgriwebbMobs(mobs: AgriWebbSeasonalMobResultT) {
    agriwebbMobs.value = mobs
  }

  function setAgriwebbMobsError(code: string | undefined) {
    agriwebbMobsError.value = code
  }

  function reset() {
    agriwebbFarms.value = undefined
    agriwebbFarmsError.value = undefined
    agriwebbMobs.value = undefined
    agriwebbMobsError.value = undefined
  }

  watch(
    () => organisationStore.currentOrgId,
    () => reset(),
  )

  return {
    agriwebbFarms,
    agriwebbFarmsError,
    agriwebbMobs,
    agriwebbMobsError,
    agriwebbReauthRequired,

    setAgriwebbFarms,
    setAgriwebbFarmsError,
    setAgriwebbMobs,
    setAgriwebbMobsError,
    reset,
  }
})
